module.exports = __webpack_public_path__ + "img/rouler_positions_7_back.1a354cb9.png";